import {
  queryDonationCampaign,
  getDonationCampaign,
  getDonationCampaignMetrics,
} from '@wix/ambassador-donations-v1-donation-campaign/http';

export const queryDonationCampaignV1 = queryDonationCampaign;
export const getDonationCampaignV1 = getDonationCampaign;
export const getDonationCampaignMetricsV1 = getDonationCampaignMetrics;

export {
  getDonationCampaign,
  queryDonationCampaigns,
  getDonationCampaignMetrics,
} from '@wix/ambassador-donations-v2-donation-campaign/http';
